import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { cn } from 'utils/cn';


interface Props {
  value: string
}


export const StatusBadge = ({ value }: Props) => {
  const { t } = useTranslation();
  const baseClass = 'absolute left-2 bottom-2 text-textcolor';

  const badges = [
    {
      key: 'approved',
      label: t('status_badge.complete', 'Approved'),
      additionalClass: 'bg-primary'
    },
    {
      key: 'in-progress',
      label: t('status_badge.in_progress', 'In Progress'),
      additionalClass: 'bg-ata-orange'
    },
    {
      key: 'needs-review',
      label: t('status_badge.needs_review', 'Needs Review'),
      additionalClass: 'bg-ata-gold'
    },
  ];

  const badge = badges.find(b => b.key === value);

  if (!badge) return false;

  return <AnimatedBadge key={badge.key} className={`${baseClass} ${badge.additionalClass}`}>
    {badge.label}
  </AnimatedBadge>
};


interface AnimatedBadgeProps {
  className: string;
  children: React.ReactNode;
}

const AnimatedBadge = ({ className, children }: AnimatedBadgeProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0 }}
      className={cn('inline-flex h-5 items-center rounded-md border-transparent px-1.5 py-2 text-xs font-medium text-white transition-colors z-10', className)}
    >
      {children}
    </motion.div>
  );
};